<style scope>
</style>

<template>
  <div>
    <b-table :data="lista" :loading="loading" class="row-click"
             :paginated="true" :perPage="20" detailed :default-sort-direction="'desc'"
             default-sort="DT_EMISSAO">
      <portal-lista-vazia slot="empty"/>

      <template slot-scope="props">

        <b-table-column label="Código Web">
          {{ props.row.CODIGOWEB }}
        </b-table-column>

        <b-table-column label="Cliente CNPJ">
          {{ props.row.CNPJ | cpfcnpj }}
        </b-table-column>

        <b-table-column label="Cliente Nome" field="RAZAO" sortable>
          <b-tooltip :label="props.row.prospect.FANTASIA">
            {{ props.row.prospect.RAZAO }}
          </b-tooltip>
        </b-table-column>

        <b-table-column label="Data Emissão" field="DT_EMISSAO" sortable>
          {{ props.row.DT_EMISSAO ? new Date(props.row.DT_EMISSAO).toLocaleDateString() : ' - ' }}
        </b-table-column>

        <b-table-column label="Data Entrega">
          {{ props.row.DT_ENTREGA ? new Date(props.row.DT_ENTREGA).toLocaleDateString() : ' - ' }}
        </b-table-column>

        <b-table-column label="Total" field="VALOR" sortable>
          {{ props.row.VALOR | moeda }}
        </b-table-column>

        <b-table-column label="Descontos">
          <b-tag>{{props.row.DESC1}}%</b-tag>
          <b-tag>{{props.row.DESC2}}%</b-tag>
          <b-tag>{{props.row.DESC3}}%</b-tag>
          <b-tag>{{props.row.DESC4}}%</b-tag>
        </b-table-column>

        <b-table-column label="Status">
          <b-tag type="is-info" v-if="props.row.STATUS === 'E'">Enviado</b-tag>
          <b-tag type="is-danger" v-if="props.row.STATUS === 'A'">Aguardando</b-tag>
          <b-tag type="is-success" v-if="props.row.STATUS === 'P'">Processado</b-tag>
          <b-tag type="is-warning" v-if="props.row.STATUS === 'X'">Editável</b-tag>
        </b-table-column>

        <b-table-column label="Download" :visible="true">
            <button class="button is-small" @click="downloadOrcamentoProspect(props.row.CODIGOWEB)"
                    title="Download">
                <b-icon icon="file-pdf"/>
            </button>
        </b-table-column>    

         <b-table-column label="Editar">            
            <b-tooltip label="Editar Orçamento">
              <button class="button is-small is-info" @click="editarOrcamento(props.row.CODIGOWEB)" v-if="props.row.STATUS === 'X'">
                <b-icon icon="pencil"/>
              </button>
            </b-tooltip>
          </b-table-column>
      </template>

      <template slot="detail" slot-scope="props">
        <table class="table is-fullwidth m-t-sm" v-if="props.row.itens.length > 0">
          <tr>
            <th>Item</th>
            <th>Código</th>
            <th>Descrição</th>
            <th>Qtd</th>
            <th >Valor tabela</th>
            <th>Valor venda</th>
            <th>Desconto(%)</th>
            <th>Comissão(%)</th>
            <th>Total do Item</th>
          </tr>
          <tr v-for="(item,i) in props.row.itens" :key="i">
            <td>{{ item.NUMITEM }}</td>
            <td>{{ item.COD_ITEM }}</td>
            <td>{{ item.DESCRICAO }}</td>
            <td class="has-text-centered">{{ item.QUANT }}</td>
            <td class="has-text-centered">{{ item.VALOR_TABELA | moeda}}</td>
            <td class="has-text-centered">{{ item.VALOR_VENDA | moeda}}</td>
            <td class="has-text-centered">
              {{item.DESCONTO }}%
            </td>
            <td class="has-text-centered">
              {{ item.COMISSAO_ITEM }}%
            </td>
            <td class="has-text-centered">{{ item.VALOR_TOTAL | moeda }}</td>
          </tr>
        </table>
      </template>

    </b-table>

  </div>
</template>

<script>
  export default {
    props: ['lista', 'loading', 'parametros'],
    methods: {
      created () {
        this.dataEntregaVisivel = false
      },
      data () {
        return {
          dataEntregaVisivel: false
        }
      },
      downloadOrcamentoProspect (codWeb) {
        this.isLoading = true
        this.$http({
          method: 'get',
          url: this.$URL.DOWNLOAD.ORCAMENTO_PROSPECT + codWeb,
          responseType: 'arraybuffer'
        })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'ORCAMENTO_PROSPECT_' + codWeb + '.pdf')
            document.body.appendChild(link)
            link.click()
            this.isLoading = false
          })
          .catch((response) => {
            this.$toast.open({
              message: 'Não foi possível localizar o orçamento para download.',
              type: 'is-danger',
              duration: 4 * 1000
            })
            this.isLoading = false
          })
      },
      editarOrcamento (codigo) {
        this.$router.push('/orcamento/prospect/edit/' + codigo)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/orcamento/ListaProspect.vue